import { render } from "./RenderShimmer.vue?vue&type=template&id=42ea6ded&scoped=true"
const script = {}

import "./RenderShimmer.vue?vue&type=style&index=0&id=42ea6ded&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ea6ded"]])

export default __exports__